import React from 'react';

import { OmniSearchBox, EXAMPLE_TOPICS, EXAMPLE_QUESTIONS } from '../OmniSearchBox';

interface OmniBoxExpandedProps {
  onClose: () => void;
}

/** Provides the expanded OmniBox search dialog. */
export const OmniBoxExpanded: React.FC<OmniBoxExpandedProps> = ({ onClose }) => {
  return (
    <OmniSearchBox
      onClose={onClose}
      example_topics={EXAMPLE_TOPICS}
      example_questions={EXAMPLE_QUESTIONS}
    />
  );
};
